import { Button } from '@mui/material';
import styled from 'styled-components';
import colors from '@/styles/colors';

export const StyledContainer = styled.section``;

export const StyledSectionTitle = styled.h2`
  margin: 10px 0;
  font-size: 1.5em;
  font-weight: bold;
  color: ${colors.light};
`;

export const StyledGridItem = styled.div`
  padding: 0 20px 10px;
  margin-top: -2px;
  border-left: 2px solid ${colors.primary};
  text-align: justify;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50px;
    left: -7px;
    top: 0;
    background: #fff;
    border: 2px solid ${colors.primary};
    transition: all 0.8s ease-in-out;
  }
`;

export const StyledGridItemTitle = styled.h3`
  margin-top: 16px;
  font-size: 1em;
  font-weight: bold;
  color: ${colors.light};
`;

export const StyledGridItemSubTitle = styled.h4`
  font-size: 1em;
  color: ${colors.light};
`;

export const StyledGridItemExtraTitle = styled.h4`
  font-size: 1em;
`;

export const StyledGridItemDescription = styled.p`
  white-space: pre-line;
  font-size: 13px;
`;

export const StyledGridList = styled.ul`
  display: block;
  list-style-type: none;
  margin-top: 10px;
`;

export const StyledGridListItem = styled.li`
color: ${colors.light};
`;

export const StyledButton = styled(Button)`
  color: ${colors.primary}!important;
  &.Mui-disabled {
    pointer-events: all;
    cursor: not-allowed;
    background: ${colors.dark};
  }
`;
